import React, { useEffect, useState } from 'react';
import {
    ServiceFilterItem,
    Check
} from './index.style'
import IconTick from '@svgs/IconTick';
import PropTypes from 'prop-types';

const Item = ({item, handleClick, currentServiceFilter}) => {

    const [active, setActive] = useState(false);

    useEffect(() => {
        if(currentServiceFilter.includes(item.slug)){
            setActive(true);
        }else{
            setActive(false);
        }
    } , [currentServiceFilter]);

    return (
        <ServiceFilterItem onClick={() => handleClick(item.slug)} ><Check active={active}><IconTick /></Check>{item.title}</ServiceFilterItem>
    );
};

Item.propTypes = {
    
};

export default Item;